import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import mergePaginatedNotifications from '../../../utils/merge-paginated-notifications';
export var mergeGroups = function mergeGroups(existingGroups, groups) {
  if (groups.length === 0) {
    return existingGroups;
  }
  return groups.reduce(function (updatedGroups, newGroup) {
    var index = updatedGroups.findIndex(function (group) {
      return group.id === newGroup.id;
    });
    if (index === -1) {
      updatedGroups.push(newGroup);
    } else {
      var group = updatedGroups[index];
      group.notifications = mergePaginatedNotifications(updatedGroups[index].notifications, newGroup.notifications);
      updatedGroups[index] = _objectSpread({}, group);
    }
    return updatedGroups;
  }, _toConsumableArray(existingGroups));
};